import { Component, OnInit, inject, input, output } from '@angular/core';
import { Assessment, ExamStatus, Group } from '$synapse/models';
import { AssessmentService, GroupService } from '$synapse/services';
import { avatarStyle } from '$synapse/core';
import { SHARED_IMPORTS } from '../../../core/shared-imports';
import { CertifiedAssessmentIconComponent } from '../../../core/components/certified-assessment-icon/certified-assessment-icon.component';

export type Filter = {
  assessments: Assessment[];
  groups: Group[];
  status: ExamStatus[];
};

type Checkbox<T> = {
  value: T;
  selected: boolean;
};

@Component({
  selector: 'syn-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  imports: [SHARED_IMPORTS, CertifiedAssessmentIconComponent],
})
export class FilterComponent implements OnInit {
  private readonly assessmentService = inject(AssessmentService);
  private readonly groupService = inject(GroupService);

  readonly filter = output<Filter>();
  readonly filterBy = input('');
  filters = [];
  appliedFilters: Filter = {
    assessments: [],
    groups: [],
    status: [],
  };
  assessments: Checkbox<Assessment>[] = [];
  groups: Checkbox<Group>[] = [];

  status: Checkbox<ExamStatus>[] = Object.values(ExamStatus).map((status) => ({
    value: status as ExamStatus,
    selected: false,
  }));

  ngOnInit(): void {
    switch (this.filterBy()) {
      case 'Examen': {
        this.assessmentService.findAll().subscribe((assessments) => {
          this.assessments = assessments.map((assessment) => ({
            value: assessment,
            selected: false,
          }));
          this.filters = this.assessments;
        });
        break;
      }
      case 'Groupe': {
        this.groupService.findAllGroups().subscribe((groups) => {
          this.groups = groups.map((group) => ({
            value: group,
            selected: false,
          }));
          this.filters = this.groups;
        });
        break;
      }
      case 'Statut': {
        this.filters = this.status;
        break;
      }
    }
  }

  changeSelection() {
    switch (this.filterBy()) {
      case 'Examen': {
        this.appliedFilters.assessments = this.assessments
          .filter((checkbox) => checkbox.selected)
          .map((checkbox) => checkbox.value);
        break;
      }
      case 'Groupe': {
        this.appliedFilters.groups = this.groups
          .filter((checkbox) => checkbox.selected)
          .map((checkbox) => checkbox.value);
        break;
      }
      case 'Statut': {
        this.appliedFilters.status = this.status
          .filter((checkbox) => checkbox.selected)
          .map((checkbox) => checkbox.value);
        break;
      }
    }
    this.filter.emit(this.appliedFilters);
  }

  clearAll() {
    switch (this.filterBy()) {
      case 'Examen': {
        this.assessments.forEach((checkbox) => {
          checkbox.selected = false;
        });
        this.appliedFilters.assessments = [];
        break;
      }
      case 'Groupe': {
        this.groups.forEach((checkbox) => {
          checkbox.selected = false;
        });
        this.appliedFilters.groups = [];
        break;
      }
      case 'Statut': {
        this.status.forEach((checkbox) => {
          checkbox.selected = false;
        });
        this.appliedFilters.status = [];
        break;
      }
    }
    this.filter.emit(this.appliedFilters);
  }

  getStatusTitle(status: ExamStatus): string {
    return avatarStyle[status]?.title || status;
  }

  displayingCertifyingAssessmentIcon(assessment: Assessment): boolean {
    return this.filterBy() === 'Examen' && assessment.isCertifying;
  }
}
